import { Component, OnInit } from '@angular/core';

@Component({
    template: `<div style="text-align: center">
    <br/><br/><br/>
    <h1>404</h1>
    <br/><br/><br/>
    <h2 i18n>Page Not Found</h2>
  </div>`,
    standalone: false
})
export class NotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
